import { useSelector } from 'react-redux';

const selectComponentIdExperiment = (state, componentId) =>
  componentId && typeof state.experimentation?.componentExperiments === 'object'
    ? state.experimentation?.componentExperiments[componentId]
    : undefined;

const selectComponentNameExperiment = (state, componentName) =>
  typeof state.experimentation?.componentExperiments === 'object'
    ? state.experimentation?.componentExperiments[componentName]
    : undefined;

/**
 * Hook to get the experiment name for a component.
 */
const useGetExperimentName = ({ componentId, componentName }) => {
  const componentIdExperiment = useSelector((state) =>
    selectComponentIdExperiment(state, componentId)
  );

  const componentNameExperiment = useSelector((state) =>
    selectComponentNameExperiment(state, componentName)
  );

  // This is used to forcibly replace all component imports with a specific experiment name for testing purposes.
  if (process.env.COMPONENT_EXPERIMENTS_TEST_OVERRIDE) {
    const testingExperiments = JSON.parse(
      process.env.COMPONENT_EXPERIMENTS_TEST_OVERRIDE
    );
    return testingExperiments[componentName];
  }

  if (componentIdExperiment) {
    return componentIdExperiment;
  }

  return componentNameExperiment || 'default';
};

export default useGetExperimentName;
